import { render, staticRenderFns } from "./LazyLoad.vue?vue&type=template&id=95bdc1ec"
import script from "./LazyLoad.vue?vue&type=script&lang=js"
export * from "./LazyLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports